import {
    createAsyncThunk,
    createSelector,
    createSlice,
  } from "@reduxjs/toolkit";
  import httpRequest from "../../services/httpRequest";
  import { saveAs } from 'file-saver';
  import snakecaseKeys from 'snakecase-keys';
  import { PAGINATION } from "config/AppConfig";
  // Main URL Endpoint
  const _urlPrefix = "/import-client";
  
  export const downloadTemplate = createAsyncThunk(
    "importClient/downloadTemplate",
    async () => {
      const result = await httpRequest({
          url: `${_urlPrefix}/download-template`,
          method: "GET"
      });
      if (!result) {
          return;
      }
      const blob = new Blob(['\ufeff', result], { type: 'text/plain;charset=utf-8' });
      saveAs(blob, 'Template-Import-Client-CSV.csv');
      return result.data;
    }
  );
  
  export const loadImportClient = createAsyncThunk(
    "importClient/loadImportClient",
    async (params) => {
      const result = await httpRequest({
        url: `${_urlPrefix}/page`,
        method: "GET",
        params
      });
      if (!result) {
        return;
      }
      return result.data;
    }
  );
  
  export const uploadClientCSV = createAsyncThunk(
    "importClient/uploadClientCSV",
    async (params, { dispatch, getState }) => {
      const { fileImport, isOverride } = params;
      const contentData = { isOverride };

      const data = new FormData();
      data.append('file', fileImport);
      data.append('client-import-csv-request', new Blob([JSON.stringify(snakecaseKeys(contentData))], {
        type: 'application/json'
      }));
      const result = await httpRequest({
        url: `${_urlPrefix}/upload-csv`,
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: data,
        successMessage: "toast.import.200"
      });
      if (!result) {
        return;
      }
      const state = getState().importClient;
      dispatch(loadImportClient({
        page: 1,
        size: state.cachedSize,
        search_key: state.cachedSearchKey
      }));
      dispatch(checkImportClientProgress());
      return result.data;
    }
  );
  
  export const downloadClientFileLogs = createAsyncThunk(
    "importClient/downloadClientFileLogs",
    async (params) => {
      const result = await httpRequest({
        url: `${_urlPrefix}/download-error-file`,
        method: "GET",
        params: {
          id: params.id
        }
      });
      if (!result) {
        return;
      }
      const blob = new Blob(['\ufeff', result], { type: 'text/plain;charset=utf-8' });
      saveAs(blob, params.fileName);
      return result.data;
    }
  );
  
  export const checkImportClientProgress = createAsyncThunk(
    "importClient/checkImportClientProgress",
    async (params, { dispatch, getState }) => {
      const result = await httpRequest({
        url: `${_urlPrefix}/check-progress-import-client`,
        method: "GET"
      });
      if (!result) {
        return;
      }
      if (result.data.length === 0) {
        const state = getState().importClient;
        dispatch(loadImportClient({
          page: state.cachedPage,
          size: state.cachedSize,
          search_key: state.cachedSearchKey
        }));
      }
      return result.data;
    }
  );
  
  const initialState = {
    importClients: [],
    paginationImport: {
      ...PAGINATION
    },
    listWrorkerProgressNote: [],
    progressingFiles: [],
    isUploadClientCSV: false,
    isImportError: false,
    cachedPage: 1,
    cachedSize: 10,
    cachedSearchKey: "",
  };
  
  const importClient = createSlice({
    name: "importClient",
    initialState: initialState,
    reducers: {
      setImportClientCachedPage: (state, { payload }) => {
        state.cachedPage = payload;
      },
      setImportClientCachedSize: (state, { payload }) => {
        state.cachedSize = payload;
      },
      setImportClientCachedSearchKey: (state, { payload }) => {
        state.cachedSearchKey = payload;
      },
    },
    extraReducers: {
        [loadImportClient.pending]: (state, action) => {
            const { meta: { arg } } = action;
            state.paginationImport = {
                ...state.paginationImport,
                ...arg
            };
        },
        [loadImportClient.fulfilled]: (state, action) => {
            const { payload } = action;
            if (payload) {
                state.importClients = [...payload.content];
                state.paginationImport.size = payload.pageSize;
                state.paginationImport.totalRecords = payload.totalElements;
                state.paginationImport.totalPages = payload.totalPages;
                state.paginationImport.page = payload.pageNumber;
                state.paginationImport = { ...state.paginationImport };
            }
            return state;
        },
        [uploadClientCSV.pending]: (state) => {
                state.isUploadClientCSV = true
                state.isImportError = false;
            return state;
        },
        [uploadClientCSV.fulfilled]: (state) => {
                state.isUploadClientCSV = false;
                return state;
        },
        [uploadClientCSV.rejected]: (state) => {
            state.isUploadClientCSV = false;
            state.isImportError = true;
            return state;
        },
        [checkImportClientProgress.fulfilled]: (state, action) => {
            const { payload } = action;
            state.progressingFiles = [...payload];
            return state;
        },
    }
  });
  
const { reducer, actions } = importClient;
export const { setImportClientCachedPage, setImportClientCachedSize, setImportClientCachedSearchKey } = actions;
export default reducer;
  

export const fetchImportClients = createSelector(
    state => state.importClient.importClients,
    importClients => importClients
);
  
export const fetchPaginationImport = createSelector(
    state => state.importClient.paginationImport,
    paginationImport => paginationImport
);
  
export const fetchProgressingClientFiles = createSelector(
    state => state.importClient.progressingFiles,
    progressingFiles => progressingFiles
);
  
export const fetchFileNameClientImport = createSelector(
    state => state.importClient.fileNameImport,
    fileNameImport => fileNameImport
);
  
export const getIsUploadClientCSV = createSelector(
    state => state.importClient.isUploadClientCSV,
    isUploadClientCSV => isUploadClientCSV
);

export const getImportClientCachedPage = createSelector(
    state => state.importClient.cachedPage,
    cachedPage => cachedPage
);

export const getImportClientCachedSize = createSelector(
    state => state.importClient.cachedSize,
    cachedSize => cachedSize
);

export const getImportClientCachedSearchKey = createSelector(
    state => state.importClient.cachedSearchKey,
    cachedSearchKey => cachedSearchKey
);
  